import React from 'react'
import { BiArrowBack, BiChevronRight } from 'react-icons/bi'
import './Breadcrumbs.css'

// Reusable breadcrumb trail. `crumbs` is an ordered array of { label, onClick }.
// Any crumb with an onClick renders as a clickable/muted link; the final crumb is
// the current page (bold, non-interactive). A back arrow precedes the first crumb
// when it is clickable, matching the "‹ Parent › Current" pattern. Callback-based
// (not router-bound), so it works for routed pages and in-page view toggles alike.
const Breadcrumbs = ({ crumbs, className }) => {
  if (!crumbs || crumbs.length === 0) {
    return null
  }

  return (
    <nav
      className={`app-breadcrumbs d-flex align-items-center ${className || ''}`}
      aria-label="Breadcrumb"
    >
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1
        const clickable = !isLast && Boolean(crumb.onClick)
        return (
          <React.Fragment key={idx}>
            {clickable ? (
              <span
                className="app-breadcrumb-link cursor-pointer"
                onClick={() => crumb.onClick()}
              >
                {idx === 0 ? (
                  <BiArrowBack className="app-breadcrumb-back" />
                ) : null}
                {crumb.label}
              </span>
            ) : (
              <span
                className={
                  isLast ? 'app-breadcrumb-current' : 'app-breadcrumb-text'
                }
              >
                {crumb.label}
              </span>
            )}
            {!isLast ? (
              <BiChevronRight className="app-breadcrumb-sep" />
            ) : null}
          </React.Fragment>
        )
      })}
    </nav>
  )
}

export default Breadcrumbs
